import { render, staticRenderFns } from "./forgot-password-card.vue?vue&type=template&id=7e0cb500&scoped=true&"
import script from "./forgot-password-card.vue?vue&type=script&lang=js&"
export * from "./forgot-password-card.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password-card.vue?vue&type=style&index=0&id=7e0cb500&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0cb500",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCol,VForm,VRow,VTextField})
